<template>
    <div id="home_welcome"
        v-if="isShowWelcome">
        <div id="home_welcome_wrapper">
            <div id="home_welcome_img_wrapper"
                :class="{'home-ambassador-img': isAmbassador}">
                <img id="home_welcome_img" class="img-fluid" :src="getCardImg()" />
            </div>
            <div id="home_welcome_content">
                <div id="home_welcome_txt">{{welcomeTxt}}</div>
                <!-- <div id="home_welcome_lvl">{{welcomeLvl}}</div> -->
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Locale from '@/helper/locale/locale';
export default {
    name: 'HomeWelcome',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        tier: function () {
            return this.$store.state.tier;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    props: {
        lbl: Object,
        localeCode: Number,
        welcomeConfig: Object
    },
    data: function () {
        return {
            isShowWelcome: false,
            welcomeTxt: '',
            welcomeLvl: '',
            locale: Locale.getLocale()
        };
    },
    created: function () {
        this.initialWelcome();
    },
    methods: {
        //initial
        initialWelcome: function () {
            var tier = this.tier;
            if (tier != 'm' || this.isAmbassador) {
                if (!this.welcomeConfig.isEnable) return;

                this.isShowWelcome = true;
                if (this.isAmbassador) {
                    var am_level = this.welcomeConfig.ambassador_level[this.locale.code.toString()];
                    this.welcomeLvl = am_level[this.tier];
                    this.welcomeTxt = this.welcomeConfig.ambassador[this.locale.code.toString()];
                } else {
                    var level = this.welcomeConfig.non_ambassador_level[this.locale.code.toString()];
                    this.welcomeLvl = level[this.tier];
                    this.welcomeTxt = this.welcomeConfig.non_ambassador[this.locale.code.toString()];
                }
            }
        },
        //method
        getCardImg: function () {
            var blob_path = `${Vue.bzbsConfig.bzbsBlobUrl}/aia/prestige/card`;
            if (this.isAmbassador)
                return `${blob_path}/ambassador/${this.tier}`;
            else
                return `${blob_path}/non_ambassador/${this.tier}`;
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#home_welcome {
    padding: {
        left: 15px;
        right: 15px;
    }
    margin-bottom: 15px;

    #home_welcome_wrapper {
        @extend %display-flex;
        padding: 3px 10px 3px 5px;
        border-radius: 6px;
        background-color: #ffffff;

        #home_welcome_img_wrapper {
            width: 20%;
            flex: 0 0 20%;
            margin: {
                top: auto;
                bottom: auto;
            };
            border-right: 1px solid #ede9de;

            #home_welcome_img {
                width: 100%;
            }
        }

        #home_welcome_content {
            width: 80%;
            flex: 0 0 80%;
            padding: {
                left: 7px;
            }
            margin: {
                top: auto;
                bottom: auto;
            }

            //font
            color: $prestige_font_color;
            // font-family: $heading;
            // line-height: 1;

            #home_welcome_txt {
                font-size: 1.375rem;

                @media(max-width: $max-width-mini-mobile){
                    font-size: 1.15rem;
                }
            }

            #home_welcome_lvl {
                font-size: 1.125rem;

                @media(max-width: $max-width-mini-mobile){
                    font-size: 1rem;
                }
            }
        }
    }
}
</style>
